import React from 'react';
import PropTypes from 'prop-types';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const Editor = ({ value, onChange, placeholder }) => {
  return (
    <div className="mt-5" style={{ minHeight: '100px', maxHeight: '200px', overflowY: 'auto' }}>
      <ReactQuill
        formats={['bold', 'italic', 'underline', 'link', 'list', 'blockquote']}
        modules={{
          toolbar: [
            ['bold', 'italic', 'underline'],
            ['link'],
            [{ list: 'ordered' }, { list: 'bullet' }, { list: 'ordered' }],
            ['blockquote', 'clean'],
          ],
        }}
        placeholder={placeholder}
        theme="snow"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

Editor.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
};

export default Editor;
